<template>
  <div>
    <!-- <div id="flow">
      <span class="flow-1"></span>
      <span class="flow-2"></span>
      <span class="flow-3"></span>
    </div>-->

    <nav class="navbar">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" id="title-header" @click="toHome()">Assets</a>
          <a
            role="button"
            class="navbar-burger burger"
            aria-label="menu"
            aria-expanded="false"
            @click="switchShow"
            v-bind:class="[show ? 'is-active' : '']"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div id="navbarMenu" class="navbar-start" v-if="show">
          <a class="navbar-item" @click="toHome()" :class="{'is-active': isActive('')}">Home</a>
          <a class="navbar-item" @click="toAdd()" :class="{'is-active': isActive('add')}">Add plugin</a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  created() {
    if (!this.isMobile) this.show = true;
  },
  computed: {
    isMobile() {
      return screen.width < 1024;
    }
  },
  methods: {
    switchShow() {
      this.show = !this.show;
    },
    toHome() {
      this.$router.push("/");
    },
    toAdd() {
      this.$router.push("/add");
    },
    isActive(type) {
      return '/' + type === this.$route.path;
    },
  },
  watch: {
    $route(to, from) {
      if (this.isMobile)
        this.show = false;
    }
  }
};
</script>